'use strict'

var RefreshControl = {
  configure: function() {},
  endRefreshing: function() {}
}

export default RefreshControl
